import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { SnackbarService } from "@ctsolution/ct-framework";
import { AddressBookParameter } from "src/app/core/classes/address-book.parameter";
import { AddressBookDetailComponent } from "./address-book-detail/address-book-detail.component";
import { AddressBookContactParameter } from "src/app/core/classes/address-book-contact.parameter";
import { AddressBookContactFormComponent } from "./address-book-contact/address-book-contact-form/address-book-contact-form.component";
import { AddressBookContactComponent } from "./address-book-contact/address-book-contact.component";

@Injectable()

export class AddressBookService {

  constructor(
    private dialog: MatDialog,
    private _snackbar: SnackbarService) {
  }


  edit = (data?: AddressBookParameter | null) => this.dialog
    .open(AddressBookDetailComponent, { width: "850px", data });

  editContact = (data?: AddressBookContactParameter | null) => this.dialog
    .open(AddressBookContactFormComponent, { width: "850px", data });

  selectContact = (data?: AddressBookContactParameter | null) => this.dialog
    .open(AddressBookContactComponent, { maxHeight: '80vh',data });

}